import jQuery from 'jquery';
import { getBrowserSize } from '../common/utils.jsx';
import _ from './i18n.jsx';
import * as ld from 'lodash';
import { NODE_TYPE_GROUP } from './engine/node.types.jsx';
import { LANGUAGES } from './constants.jsx';

export function getQuestionsQuantity(pageList, fields) {
    let quantity = 0;
    ld.forEach(pageList, (page) => {
        if (!page.condition) { quantity += page.questionsQuantity; }
        if ('function' === typeof page.condition && page.condition(fields)) { quantity += page.questionsQuantity; }
    });
    return quantity;
}

export function animateScrollToPage(pageIndex, finished = false) {
    const windowHeight = getBrowserSize().height;
    const wrapper = document.querySelector('.questionnaire-constructor-wrapper');
    if (null === wrapper) {
        setTimeout(animateScrollToPage.bind(null, pageIndex, finished), 200);
        return;
    }
    const nextPage = wrapper.childNodes[pageIndex];
    nextPage.style.display = 'block';
    nextPage.style.minHeight = finished ? 0 : `${windowHeight}px`;
    const scrollValue = nextPage.offsetTop - wrapper.offsetTop;
    jQuery('html,body').animate({ scrollTop: scrollValue }, {
        duration: 'slow',
        easing: 'swing'
    });
}

export function getQuestionnaireToken() {
    const TOKEN_INPUT = document.getElementById('questionnaire-token');
    if (TOKEN_INPUT && TOKEN_INPUT.value) { return TOKEN_INPUT.value; }

    console.warn('Node with questionnaire token not found or has empty value');
    const matchResult = /^questionnaire\/([A-Za-z0-9]{40})\/?$/.exec(location.pathname);
    if (matchResult) { return matchResult.pop(); }
    console.error('Questionnaire token not found. Panic!');
    return null;
}

export function reverseRelationTypeToGenderRelation(relation, gender) {
    const relationMap = {
        sibling: { male: _('Brother'), female: _('Sister') },
        children: { male: _('Son'), female: _('Daughter') },
        cousin: { male: _('Cousin'), female: _('Cousin') },
        uncle: { male: _('Uncle'), female: _('Aunt') },
        nephew: { male: _('Nephew'), female: _('Niece') }
    };
    return relationMap[relation.toLowerCase()][gender.toLowerCase()];
}

export function dropGroups(page) { return page.nodeType !== NODE_TYPE_GROUP; }

export function mapPageToNavigationElement(page) {
    return {
        id: page.id,
        condition: page.props.condition || false,
        title: page.props.title || page.group,
        group: page.group,
        questionsQuantity: page.childrenNodes.length,
        header: page.header || false,
        nodeType: page.nodeType
    };
}

export const EMPTY_ARRAY = [];

export const EMPTY_OBJECT = {};

export const EMPTY_STRING = '';

export const SINGLE_SPACE = ' ';

export const STYLE_DISPLAY_NONE = { display: 'none' };

export const STYLE_DISPLAY_BLOCK = { display: 'block' };

export function getQuestionnaireLanguage() {
    let locale;
    const language = window.location.pathname ? window.location.pathname.split('/')[2].substr(0, 2) : EMPTY_STRING;
    switch (language) {
        case 'en':
            locale = LANGUAGES.ENGLISH;
            break;
        case 'es':
            locale = LANGUAGES.SPANISH;
            break;
        case 'pt':
            locale = LANGUAGES.PORTUGUESE;
            break;
        default:
            locale = LANGUAGES.ENGLISH;
    }
    return locale;
}
